import { Pipe, PipeTransform } from '@angular/core';
import { Supplier } from '../../classes/supplier';

@Pipe({
  name: 'supplierIdFilter',
  pure: false
})
export class SupplierIdFilterPipe implements PipeTransform {

  transform(supplierList: Array<Supplier>, filterValue: string): any {
    if (!supplierList || !filterValue) {
      return supplierList;
    }
    const normalizedFilter = filterValue.toString().trim().toLowerCase();
    return supplierList.filter(supplier =>
      String(supplier.IDSupplier ?? '').toLowerCase().indexOf(normalizedFilter) !== -1
    );
  }

}
